// "AI fix vs final" for a heal job approved with edits (DPS-4718).
//
// The healing agent records review_context.reviewer_edit on approve with edits
// (agentic-anomaly-healing src/utils/reviewer-edit.ts):
//   { kinds, edited_config?, edited_parsed_config?, summary, recorded_at }
// edited_config / edited_parsed_config are present only when they differ from
// the agent's fix. The agent's fix stays in review_context.repair_config and
// repair_parsed_config (the agent compares against those; for the parsed
// config the edit dialog starts from old_parsed_config when there is no repair_parsed_config).

const isPlainObject = (v) => v !== null && typeof v === 'object' && !Array.isArray(v);

/**
 * { kinds, summary, config: {ai, final} | null, parsed: {ai, final} | null },
 * or null when the job carries no reviewer edit to show.
 */
export function reviewerEditDiff(ctx) {
  const edit = ctx?.reviewer_edit;
  if (!isPlainObject(edit)) return null;

  const config = Array.isArray(edit.edited_config)
    ? { ai: Array.isArray(ctx.repair_config) ? ctx.repair_config : [], final: edit.edited_config }
    : null;
  const parsed = isPlainObject(edit.edited_parsed_config)
    ? { ai: ctx.repair_parsed_config || ctx.old_parsed_config || {}, final: edit.edited_parsed_config }
    : null;
  if (!config && !parsed) return null;

  return {
    kinds: Array.isArray(edit.kinds) ? edit.kinds : [],
    summary: typeof edit.summary === 'string' ? edit.summary : '',
    config,
    parsed,
  };
}
